import React from 'react';

const AreaAddressRenderer = ({
  rowData,
  rowData: { summarized, projectLocationId, shiftLocationId },
  columnData: { mappedLocations, key = 'locationId' }
}) => {
  const locationId = rowData?.[key];
  if (summarized || (!locationId && !projectLocationId)) {
    return <></>;
  }

  if (shiftLocationId && projectLocationId && shiftLocationId !== projectLocationId) {
    return <>{`${mappedLocations[shiftLocationId]?.address} - ${mappedLocations[projectLocationId]?.address}`}</>;
  }

  return <>{mappedLocations[locationId]?.address || mappedLocations[projectLocationId]?.address || ''}</>;
};

export default AreaAddressRenderer;
